'use client';

import Link from 'next/link';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  return (
    <html>
      <body>
        <div className="min-h-screen flex items-center justify-center bg-[var(--color-neutral-50)]">
          <div className="max-w-md w-full mx-auto text-center space-y-6">
            <div className="space-y-2">
              <h2 className="text-2xl font-bold text-[var(--color-cta-danger)]">Application Error</h2>
              <p className="text-[var(--color-neutral-600)]">
                A critical error occurred in the application.
              </p>
            </div>
            <div className="flex gap-4 justify-center">
              <button
                onClick={reset}
                className="bg-[var(--color-brand-primary)] hover:bg-[var(--color-brand-primary-hover)] text-[var(--color-pure-white)] px-4 py-2 rounded-md transition-colors"
              >
                Try again
              </button>
              <Link
                href="/"
                className="bg-[var(--color-neutral-300)] hover:bg-[var(--color-neutral-400)] text-[var(--color-neutral-800)] px-4 py-2 rounded-md transition-colors inline-block"
              >
                Go home
              </Link>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
} 